


  
  

  var faAddressCard = {
    prefix: 'fasl',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M544 64l0 384L32 448 32 64l512 0zM32 32L0 32 0 64 0 448l0 32 32 0 512 0 32 0 0-32 0-384 0-32-32 0L32 32zM160 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM135.1 320l113.9 0 21.3 64 33.7 0-32-96-160 0L80 384l33.7 0 21.3-64zM352 160l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0zm0 64l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0zm0 64l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faArrowsSpin = {
    prefix: 'fasl',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1l0-32.5c10.8-1.7 21.9-2.6 33.1-2.6c53.2 0 101.7 20 138.5 52.8l13.7-13.7L432 64l22.6 22.6L464 96l0 64 0 32-32 0-64 0-9.4-9.4L336 160l22.6-22.6L373 123c-31-27.1-71.5-43.5-115.8-43.5zm-208 176c0-53 19.8-101.3 52.4-138L86.6 102.6 64 80 86.6 57.4 96 48l64 0 32 0 0 32 0 64-9.4 9.4L160 176l-22.6-22.6-13.2-13.2c-26.8 30.9-43.1 71.2-43.1 115.3c0 11.1 1 21.9 3 32.5l-32.5 0c-1.7-10.6-2.5-21.4-2.5-32.5zm384 0c0-10.8-1-21.3-2.8-31.5l32.4 0c1.6 10.3 2.4 20.8 2.4 31.5c0 53.8-20.4 102.8-53.9 139.7l14.1 14.1L448 432l-22.6 22.6L416 464l-64 0-32 0 0-32 0-64 9.4-9.4L352 336l22.6 22.6 14 13.9c27.7-31.1 44.6-72.1 44.6-117zM288 428.8l0 32.4c-10.1 1.5-20.4 2.3-30.9 2.3c-53.5 0-102.3-20.2-139.2-53.5l-15.3 15.3L80 448 57.4 425.4 48 416l0-64 0-32 32 0 64 0 9.4 9.4L176 352l-22.6 22.6-12.8 12.8c31 27.5 71.9 44.1 116.6 44.1c10.5 0 20.8-.9 30.9-2.7zM160 130.7L160 80l-50.7 0L160 130.7zm272-21.5L381.3 160l50.7 0 0-50.7zm-80 272l0 50.7 50.7 0L352 381.3zM80 402.7L130.7 352 80 352l0 50.7z'
      
    ]
  };

  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fasl',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M260.7 36.7l-80 80L169.4 128l11.3 11.3 80 80L272 230.6 294.6 208l-11.3-11.3L230.6 144 480 144l0 96 0 16 32 0 0-16 0-112 0-16-16 0-265.4 0 52.7-52.7L294.6 48 272 25.4 260.7 36.7zm-9.4 256L240 281.4 217.4 304l11.3 11.3L281.4 368 16 368 0 368l0 16L0 496l0 16 32 0 0-16 0-96 249.4 0-52.7 52.7L217.4 464 240 486.6l11.3-11.3 80-80L342.6 384l-11.3-11.3-80-80zM448 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 128a64 64 0 1 0 128 0A64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fasl',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M303.5 184.4L338.9 49.8 352 0 310.8 30.9 32 240l0 48 88.3 5.9 32.5 2.2-8.3 31.5L109.1 462.2 96 512l41.2-30.9L416 272l0-48-88.3-5.9-32.5-2.2 8.3-31.5zM384 253.9l0 2.1L150.3 431.2l33.4-127 9.9-37.5L155 264.1l-91-6.1 0-2.1L297.7 80.8l-33.4 127-9.9 37.5 38.7 2.6 91 6.1z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faBullseyeArrow = {
    prefix: 'fasl',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M323.2 8.9C301.8 3.1 279.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-23.3-3.1-45.8-8.9-67.2l-26.7 26.7c2.4 13.1 3.6 26.7 3.6 40.5c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c13.8 0 27.3 1.3 40.5 3.6L323.2 8.9zm-50 88c-5.6-.6-11.4-.9-17.2-.9C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-5.8-.3-11.5-.9-17.2l-32.6-2.5c1 6.4 1.5 13 1.5 19.7c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c6.7 0 13.3 .5 19.7 1.5l-2.5-32.6zM437.2 75.2l-.4-.4 .1 .3 .3 .1zm-56 33l-39.9 39.9-4.8-62 25.6-25.6 19.1 47.7zm-47.1 92.4l96.7 7.4 7.3 .6 5.2-5.2 48-48 17.2-17.2-22.5-9L412.3 99.7 382.9 26.1l-9-22.5L356.7 20.7l-48 48-5.2 5.2 .6 7.3 7.4 96.7-66.8 66.8L233.4 256 256 278.6l11.3-11.3 66.8-66.8zm29.8-29.8l39.9-39.9 47.7 19.1-25.6 25.6-62-4.8z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fasl',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M83.2 70.4C81.1 73.2 80 76.5 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L96 53.3 83.2 70.4zM57.6 51.2L76 26.7 96 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM211.2 70.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L224 53.3 211.2 70.4zM185.6 51.2L204 26.7 224 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM352 53.3L339.2 70.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L352 53.3zM332 26.7L352 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L332 26.7zM32 372.8l57.1-27.2 7-3.4 7 3.5L160 374.1l56.8-28.4 7.2-3.6 7.2 3.6L288 374.1l56.8-28.4 7-3.5 7.1 3.4L416 372.8 416 256l-48 0 0 16 0 16-32 0 0-16 0-16-96 0 0 16 0 16-32 0 0-16 0-16-96 0 0 16 0 16-32 0 0-16 0-16-48 0 0 116.8zm0 34.9L32 480l384 0 0-72.3c-1.2-.3-2.5-.7-3.7-1.2l-60.2-28.6-57 28.5-7.2 3.6-7.2-3.6L224 377.9l-56.8 28.4-7.2 3.6-7.2-3.6-57-28.5L35.7 406.4c-1.2 .6-2.4 1-3.7 1.2zM32 224l48 0 0-48 0-16 32 0 0 16 0 48 96 0 0-48 0-16 32 0 0 16 0 48 96 0 0-48 0-16 32 0 0 16 0 48 48 0 32 0 0 32 0 224 0 32-32 0L32 512 0 512l0-32L0 256l0-32 32 0z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faCalendarDays = {
    prefix: 'fasl',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M128 0l0 16 0 48 192 0 0-48 0-16 32 0 0 16 0 48 64 0 32 0 0 32 0 64 0 32 0 288 0 32-32 0L32 512 0 512l0-32L0 192l0-32L0 96 0 64l32 0 64 0 0-48L96 0l32 0zM416 192l-104 0 0 72 104 0 0-72zm0 104l-104 0 0 80 104 0 0-80zm0 112l-104 0 0 72 104 0 0-72zM280 376l0-80-112 0 0 80 112 0zM168 408l0 72 112 0 0-72-112 0zm-32-32l0-80L32 296l0 80 104 0zM32 408l0 72 104 0 0-72L32 408zm0-144l104 0 0-72L32 192l0 72zm136 0l112 0 0-72-112 0 0 72zM416 96L32 96l0 64 384 0 0-64z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fasl',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M416 0L400 0l0 32 16 0 71 0L320.2 171 202.5 68l-9.6-8.4-10.3 7.5-176 128 18.8 25.9L191.1 100.5 309.5 204l10.3 9 10.5-8.7L512 52.8l0 75.2 0 16 32 0 0-16 0-112 0-16L528 0 416 0zm96 32s0 0 0 0s0 0 0 0s0 0 0 0zM80 352l0 96-32 0 0-96 32 0zM48 320l-32 0 0 32 0 96 0 32 32 0 32 0 32 0 0-32 0-96 0-32-32 0-32 0zm128-64l32 0 0 192-32 0 0-192zm-32-32l0 32 0 192 0 32 32 0 32 0 32 0 0-32 0-192 0-32-32 0-32 0-32 0zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM406.6 393.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1 -50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l17.3 17.3 22.6-22.6L490 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3-22.6-22.6L467.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3-22.6 22.6L374 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3 22.6 22.6L396.7 426z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fasl',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M192 32l0 64 64 0 0-64-64 0zM160 0l32 0 64 0 32 0 0 32 0 64 0 21.3L314.7 194c6.9-1.3 14-2 21.3-2c31.7 0 60.2 13.1 80.6 34.2L512 157.6 512 96l0-32 32 0 64 0 32 0 0 32 0 64 0 32-32 0-64 0-25.1 0-83.6 60.2c8.1 15.5 12.7 33.1 12.7 51.8c0 12.3-2 24.2-5.7 35.3L531.8 384l12.2 0 64 0 32 0 0 32 0 64 0 32-32 0-64 0-32 0 0-32 0-64 0-6.1-84-42C407.8 397 374.1 416 336 416c-56.4 0-103.1-41.7-110.9-96L128 320l0 16 0 32-32 0-64 0L0 368l0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 16 97.1 0c5.2-36.4 27.9-67.2 59.3-83.5L257.8 128l-1.8 0-64 0-32 0 0-32 0-64 0-32zM336 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM96 272l-64 0 0 64 64 0 0-64zM608 96l-64 0 0 64 64 0 0-64zM544 416l0 64 64 0 0-64-64 0z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fasl',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M480 256C480 132.3 379.7 32 256 32S32 132.3 32 256c0 67.5 29.8 128 77 169l35-105 224 0 35 105c47.2-41.1 77-101.6 77-169zM376 445.2L344.9 352l-177.9 0L136 445.2c34.7 22 75.9 34.8 120 34.8c44.5 0 85.9-13 120.7-35.3l-.7 .5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fasl',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M232 415.8c-25.2-36.2-40-80.3-40-127.8c0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32C118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8c0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192s-86-192-192-192c-2.7 0-5.4 .1-8 .2z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fasl',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144 0 8.6 7.1 4.8 96 64 13.3 8.9 17.8-26.6-13.3-8.9L272 247.4 272 112l0-16-32 0 0 16z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faCodeFork = {
    prefix: 'fasl',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M128 32l0 96-32 0-32 0-32 0 0-96 96 0zM32 160l32 0 0 32c0 44.2 35.8 80 80 80l64 0 0 80-32 0-32 0 0 32 0 96 0 32 32 0 96 0 32 0 0-32 0-96 0-32-32 0-32 0 0-80 64 0c44.2 0 80-35.8 80-80l0-32 32 0 32 0 0-32 0-96 0-32L416 0 320 0 288 0l0 32 0 96 0 32 32 0 32 0 0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32 32 0 32 0 0-32 0-96 0-32L128 0 32 0 0 0 0 32l0 96 0 32 32 0zm352-32l-32 0-32 0 0-96 96 0 0 96-32 0zM240 384l32 0 0 96-96 0 0-96 32 0 32 0z'
      
    ]
  };

  

  
  

  var faCompass = {
    prefix: 'fasl',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm38.7-217.3L178.6 333.4l38.7-116.1 116.1-38.7L294.7 294.7zm51.3-154.1L192 192 140.6 346.1 128 384l37.9-12.6L320 320l51.4-154.1L384 128l-37.9 12.6zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fasl',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M479.4 240L384 240l-16 0 0 32 16 0 95.4 0C471.6 383 383 471.6 272 479.4l0-95.4 0-16-32 0 0 16 0 95.4C129 471.6 40.4 383 32.6 272l95.4 0 16 0 0-32-16 0-95.4 0C40.4 129 129 40.4 240 32.6l0 95.4 0 16 32 0 0-16 0-95.4C383 40.4 471.6 129 479.4 240zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'fasl',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M118 373c-39.8-38.3-67.9-83.7-83.2-117c15.3-33.3 43.4-78.6 83.2-117c44.6-42.9 101.5-75 170-75s125.4 32.1 170 75c39.8 38.3 67.9 83.7 83.2 117c-15.3 33.3-43.4 78.6-83.2 117c-44.6 42.9-101.5 75-170 75s-125.4-32.1-170-75zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fasl',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M32 16L32 0 0 0 0 16 0 64 0 367l0 33 0 96 0 16 32 0 0-16 0-104 96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368l0-316.2L448 16 416 32 393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56l0-40zm0 73L140.7 61.8c30.7-7.7 63.1-4.1 91.4 10c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1 0 278-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359 32 89z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fasl',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M203.3 88.7C185.1 73.3 161.7 64 136 64C78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3L74.3 256 56.7 276.7C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104c25.7 0 49.1-9.3 67.3-24.7L224 405.7l20.7 17.6C262.9 438.7 286.3 448 312 448c57.4 0 104-46.6 104-104c0-25.7-9.3-49.1-24.7-67.3L373.7 256l17.6-20.7C406.7 217.1 416 193.7 416 168c0-57.4-46.6-104-104-104c-25.7 0-49.1 9.3-67.3 24.7L224 106.3 203.3 88.7zM448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM224 352l-22.6-22.6-50.7-50.7L128 256l22.6-22.6 50.7-50.7L224 160l22.6 22.6 50.7 50.7L320 256l-22.6 22.6-50.7 50.7L224 352zm0-146.7L173.3 256 224 306.7 274.7 256 224 205.3z'
      
    ]
  };

  

  
  

  var faHeadSideBrain = {
    prefix: 'fasl',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M32 224C32 118 118 32 224 32l24 0c88.4 0 160 71.6 160 160l0 7.2 5.4 4.8L480 263.2l0 40.8-48 0-16 0 0 16 0 96-112 0-16 0 0 16 0 64 0 16 32 0 0-16 0-48 112 0 16 0 0-16 0-96 48 0 16 0 0-16 0-64 0-7.2-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0L224 0C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8L64 496l0 16 32 0 0-16 0-121.9 0-6.8-4.9-4.7C54.6 327.6 32 278.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2l7.7 13.7 13.8-7.5c2.8-1.5 6-2.4 9.5-2.4c7 0 13.2 3.6 16.8 9.1l5.6 8.6 10.1-1.5c1.1-.2 2.3-.3 3.5-.3c13.3 0 24 10.7 24 24l0 24-64 0-16 0 0 16 0 16 0 16-16 0-16 0 0 32 16 0 32 0 16 0 0-16 0-32 64 0 16 0 0-16 0-40c0-30.4-24.2-55.2-54.5-56c-9.5-9.9-22.8-16-37.5-16c-4 0-7.8 .4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3C179.8 96.4 176 96 172 96c-22.2 0-41.1 13.9-48.6 33.4C98.6 135.1 80 157.4 80 184c0 19.2 9.7 36.1 24.3 46.2c3.1 28 26.8 49.8 55.7 49.8l0 24 0 16 32 0 0-16 0-40 0-16-16 0-16 0c-13.3 0-24-10.7-24-24c0-.7 0-1.3 .1-2l.9-11.4L126.5 206c-8.6-3.7-14.5-12.2-14.5-22c0-13.3 10.7-24 24-24l.2 0 14.4 0 1.6-14.3c1.1-10 9.6-17.8 19.9-17.8c3.5 0 6.7 .9 9.5 2.4l13.8 7.5 7.7-13.7z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fasl',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M32 224C32 118 118 32 224 32l24 0c88.4 0 160 71.6 160 160l0 7.2 5.4 4.8L480 263.2l0 40.8-48 0-16 0 0 16 0 96-112 0-16 0 0 16 0 64 0 16 32 0 0-16 0-48 112 0 16 0 0-16 0-96 48 0 16 0 0-16 0-64 0-7.2-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0L224 0C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8L64 496l0 16 32 0 0-16 0-121.9 0-6.8-4.9-4.7C54.6 327.6 32 278.4 32 224zM176 104l0 16 0 20.8c-.8 .5-1.6 1-2.4 1.4l-15-8.1-13.7-7.4-7.8 13.5-32 55.4L96.9 210l14.5 7.8 11.5 6.2-11.5 6.2L96.9 238l8.2 14.3 32 55.4 7.8 13.5 13.7-7.4 15-8.1c.8 .5 1.6 1 2.4 1.4l0 20.8 0 16 16 0 64 0 16 0 0-16 0-20.8c.8-.5 1.6-1 2.4-1.4l15 8.1 13.7 7.4 7.8-13.5 32-55.4 8.2-14.3-14.5-7.8L325.1 224l11.5-6.2 14.5-7.8-8.2-14.3-32-55.4-7.8-13.5-13.7 7.4-15 8.1c-.8-.5-1.6-1-2.4-1.4l0-20.8 0-16-16 0-64 0-16 0zm32 32l32 0 0 14.7 0 10.5 9.6 4.2c5 2.2 9.6 5 13.9 8.3l8.2 6.5 9.2-5 10-5.4 16 27.7-10.8 5.8-9.2 5 .9 10.4c.1 1.8 .2 3.5 .2 5.3s-.1 3.6-.2 5.3l-.9 10.4 9.2 5 10.8 5.8-16 27.7-10-5.4-9.2-5-8.2 6.5c-4.2 3.3-8.9 6.1-13.9 8.3l-9.6 4.2 0 10.5 0 14.7-32 0 0-14.7 0-10.5-9.6-4.2c-5-2.2-9.6-5-13.9-8.3l-8.2-6.5-9.2 5-10 5.4-16-27.7 10.8-5.8 9.2-5-.9-10.4c-.1-1.8-.2-3.5-.2-5.3s.1-3.6 .2-5.3l.9-10.4-9.2-5-10.8-5.8 16-27.7 10 5.4 9.2 5 8.2-6.5c4.2-3.3 8.9-6.1 13.9-8.3l9.6-4.2 0-10.5 0-14.7zm40 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faLightbulbOn = {
    prefix: 'fasl',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9l32.4 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80l0-32c-61.9 0-112 50.1-112 112l32 0zm32 304l0-32 96 0 0 32-96 0zm-32-64l0 32 0 32 0 32 32 0 96 0 32 0 0-32 0-32 0-32-32 0-96 0-32 0zM67.2 7.7L52.8 .5 38.5 29.2l14.3 7.2 52 26 14.3 7.2 14.3-28.6-14.3-7.2-52-26zm520 28.6l14.3-7.2L587.2 .5 572.8 7.7l-52 26-14.3 7.2 14.3 28.6 14.3-7.2 52-26zM16 160L0 160l0 32 16 0 64 0 16 0 0-32-16 0-64 0zm544 0l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zM119.2 318.3l14.3-7.2-14.3-28.6-14.3 7.2-52 26-14.3 7.2 14.3 28.6 14.3-7.2 52-26zm416-28.6l-14.3-7.2-14.3 28.6 14.3 7.2 52 26 14.3 7.2 14.3-28.6-14.3-7.2-52-26z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fasl',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M156.3 58.2L166.5 46 142 25.5 131.7 37.8 62.9 120.3 27.3 84.7 16 73.4-6.6 96 4.7 107.3l48 48 12.4 12.4 11.2-13.5 80-96zm0 160L166.5 206 142 185.5l-10.2 12.3L62.9 280.3 27.3 244.7 16 233.4-6.6 256 4.7 267.3l48 48 12.4 12.4 11.2-13.5 80-96zM192 80l0 32 16 0 288 0 16 0 0-32-16 0L208 80l-16 0zm0 160l0 32 16 0 288 0 16 0 0-32-16 0-288 0-16 0zM160 400l0 32 16 0 320 0 16 0 0-32-16 0-320 0-16 0zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faMapLocationDot = {
    prefix: 'fasl',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M360.8 166.2C371.4 145.4 376 129.7 376 120c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 9.7 4.6 25.4 15.2 46.2c10.2 20 24.1 41.3 38.6 61.2c12 16.5 24.1 31.7 34.1 43.7c10-12 22.1-27.2 34.1-43.7c14.5-19.9 28.4-41.2 38.6-61.2zM309.2 295.7C296.6 310.7 288 320 288 320s-8.6-9.3-21.2-24.3C232.4 254.7 168 171.3 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 51.3-64.4 134.7-98.8 175.7zm92-70.1l-.5-.2c6.1-9.9 12-20 17.1-30.1c2-3.9 3.9-7.8 5.8-11.9L544 139.6 576 128l0 34 0 286L400 512 176 448 32 500.4 0 512l0-34.1L0 192l138.3-50.3c2.1 10.3 5.4 20.6 9.4 30.6L32 214.4l0 251.9 128-46.5L160 288l32 0 0 131.3 192 54.9L384 288l32 0 0 184.1 128-46.5 0-251.9L410.9 222.1l-9.8 3.5zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faSolarSystem = {
    prefix: 'fasl',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M32 256c0 123.7 100.3 224 224 224c31.4 0 61.4-6.5 88.5-18.2c4.2 8.8 9.9 17.1 17.3 24.4c.7 .7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512C114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5c0 0 0 0 0 0c3.4 2.2 6.7 4.7 9.7 7.7l.2 .2 .1 .1c4.9 4.9 8.6 10.5 11.3 16.4c0 0 0 0 0 0c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zM394.3 471.5s0 0 0 0c-3.5-2.2-6.8-4.8-9.8-7.8l9.8 7.8zM424 480c-10.9 0-21.1-3.1-29.7-8.5L373 447.1c-3.2-7-5-14.9-5-23.1c0-30.9 25.1-56 56-56c8.2 0 16 1.8 23.1 5c20.9-34 32.9-74.1 32.9-117C480 132.3 379.7 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0C397.4 0 512 114.6 512 256c0 50.9-14.9 98.4-40.5 138.3c5.4 8.6 8.5 18.8 8.5 29.7c0 30.9-25.1 56-56 56zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm264 80c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3c-4.2 1.5-8.8 2.3-13.5 2.3zm64 64c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1c17 25.4 27 56 27 88.9zM256 336l-22.6-22.6-34.7-34.7L176 256l22.6-22.6 34.7-34.7L256 176l22.6 22.6 34.7 34.7L336 256l-22.6 22.6-34.7 34.7L256 336zm0-114.7L221.3 256 256 290.7 290.7 256 256 221.3z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fasl',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M307.3 35.3l-56 56L240 102.6 217.4 80l11.3-11.3 56-56L296 1.4 318.6 24 307.3 35.3zm192 0l-152 152L336 198.6 313.4 176l11.3-11.3 152-152L488 1.4 510.6 24 499.3 35.3zm0 192l-56 56L432 294.6 409.4 272l11.3-11.3 56-56L488 193.4 510.6 216l-11.3 11.3zm-288-47.2l41.9 85L347 278.8l39.9 5.8-28.9 28.1-67.9 66.2 16 93.4L313 512l-35.7-18.8-83.9-44.1-83.9 44.1L73.9 512l6.8-39.7 16-93.4L28.9 312.7 0 284.6l39.9-5.8 93.8-13.6 41.9-85L193.5 144l17.8 36.2zm37.3 116.7L232 294.4l-7.4-15.1-31.1-63-31.1 63-7.4 15.1-16.6 2.4L68.8 306.9l50.3 49 12 11.7-2.8 16.6-11.9 69.2 62.2-32.7 14.9-7.8 14.9 7.8 62.2 32.7-11.9-69.2-2.8-16.6 12-11.7 50.3-49-69.5-10.1z'
      
    ]
  };

  

  
  

  var faSun = {
    prefix: 'fasl',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3 25.2 84.1 84.1 25.2L512 150l-15.5 28.8L454.9 256l41.6 77.3L512 362l-31.3 9.4-84.1 25.2-25.2 84.1L362 512l-28.8-15.5L256 454.9l-77.3 41.6L150 512l-9.4-31.3-25.2-84.1L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zm92.5 69.8L256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 5 16.5 23.3 77.8 71.5-38.5 15.2-8.2 15.2 8.2 71.5 38.5L366 387.4l5-16.5 16.5-5 77.8-23.3-38.5-71.5L418.5 256l8.2-15.2 38.5-71.5L387.4 146l-16.5-5-5-16.5L342.7 46.8 271.2 85.3zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm96 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fasl',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M4.7 27.3l64 64L80 102.6 102.6 80 91.3 68.7l-64-64L4.7 27.3zm608-22.6l-64 64L537.4 80 560 102.6l11.3-11.3 64-64L612.7 4.7zM91.3 443.3L102.6 432 80 409.4 68.7 420.7l-64 64 22.6 22.6 64-64zm480-22.6L560 409.4 537.4 432l11.3 11.3 64 64 22.6-22.6-64-64zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm80.2-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM129.4 336l14.4-48 46.5 0 3.4-10.1 7.3-21.9L120 256 96 336l33.4 0zm366.8-48l14.4 48 33.4 0-24-80-80.9 0 7.3 21.9 3.4 10.1 46.5 0zM224 288l-21.3 64L192 384l33.7 0 188.5 0 33.7 0-10.7-32L416 288l-192 0zm23.1 32l145.9 0 10.7 32-167.2 0 10.7-32z'
      
    ]
  };

  



export {

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faArrowsSpin,
  

  faArrowsTurnToDots,
  

  faBolt,
  
  faZap,
  

  faBullseyeArrow,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faChartMixedUpCircleCurrency,
  

  faChartNetwork,
  

  faCircleUser,
  
  faUserCircle,
  

  faCirclesOverlap,
  

  faClock,
  
  faClockFour,
  

  faCodeFork,
  

  faCompass,
  

  faCrosshairsSimple,
  

  faEye,
  

  faFlag,
  

  faFlower,
  

  faHeadSideBrain,
  

  faHeadSideGear,
  

  faLightbulbOn,
  

  faListCheck,
  
  faTasks,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faSolarSystem,
  

  faStarShooting,
  

  faSun,
  

  faUsersRays,
  

};
